import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import connect from 'components/lib/connect';
import ConversationItem from 'models/conversation_item';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import SwitchCurrentConversation from 'actions/customer/switch_current_conversation';

export function VoiceRecordingDeletedItem({ item, onClickRecordingLink }) {
  return (
    <ItemContent isAuditItem item={item}>
      <ItemMetadata
        item={item}
        text={
          <Trans
            components={{
              recordingLink: <a className="conversationItem-metadata-link" onClick={onClickRecordingLink} />,
            }}
            i18nKey="deleted the <recordingLink>recording</recordingLink>"
          />
        }
      />
    </ItemContent>
  );
}

VoiceRecordingDeletedItem.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  onClickRecordingLink: PropTypes.func.isRequired,
};

function mapStateToProps(context, { item }) {
  return { item };
}

function mapExecuteToProps(executeAction, { conversationId, item }) {
  return {
    onClickRecordingLink: () => {
      executeAction(SwitchCurrentConversation, {
        conversationId,
        conversationItemId: item.content.conversationItemId,
      });
    },
  };
}

const VoiceRecordingDeletedItemContainer = connect(mapStateToProps, mapExecuteToProps)(VoiceRecordingDeletedItem);

VoiceRecordingDeletedItemContainer.propTypes = {
  conversationId: PropTypes.string.isRequired,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export default VoiceRecordingDeletedItemContainer;
